const MAP_CALLBACK_NAME = '__googleMapsApiOnLoadCallback';
const OPTIONS_KEYS = ['channel', 'client', 'key', 'language', 'region', 'v'];
const OPTIONS = {
  key: 'AIzaSyArxtB1Jl5TdWxljaWqRk45Fy6lhFSBYCc',
  timeout: 10000,
}

let promise = null;
let labelPromise = null;
declare var google: any;

export function mapLoader() {
  if (!promise) {
    promise = new Promise((resolve, reject) => {
      const timeoutId = setTimeout(() => {
        window[MAP_CALLBACK_NAME] = function () {} 
        reject(new Error('Could not load the Google Maps API'));
      }, OPTIONS.timeout);

      window[MAP_CALLBACK_NAME] =  () => {
        if (timeoutId !== null) {
          clearTimeout(timeoutId);
        }
        resolve(google.maps);
        delete window[MAP_CALLBACK_NAME];
      }

      const scriptElement = document.createElement('script');
      const params = ['callback=' + MAP_CALLBACK_NAME, 'libraries=geometry'];
      OPTIONS_KEYS.forEach((key) => {
        if (OPTIONS[key]) {
          params.push(key + '=' + OPTIONS[key]);
        }
      });

      scriptElement.src ='https://maps.googleapis.com/maps/api/js?' + params.join('&');

      document.body.appendChild(scriptElement);
    })
  }

  return promise
}

export function setZoomControls(map) {
  const className = 'zoom-controls-wrapper';
  if (!!document.querySelector(`.${className}`) ||
      map.controls[window['google'].maps.ControlPosition.RIGHT_BOTTOM].length > 0) return;
  
  let zoomControlDiv = document.createElement('div');
  zoomControlDiv.className = className;


  var zoomInButton = document.createElement('div');
  zoomInButton.className = 'zoom-control-btn zoom-in';
  zoomControlDiv.appendChild(zoomInButton);
  var zoomOutButton = document.createElement('div');
  zoomOutButton.className = 'zoom-control-btn zoom-out';
  zoomControlDiv.appendChild(zoomOutButton);
  zoomInButton.addEventListener('click', () => map.setZoom(map.getZoom() + 1));
  zoomOutButton.addEventListener('click', () => map.setZoom(map.getZoom() - 1));
  map.controls[window['google'].maps.ControlPosition.RIGHT_BOTTOM].push(zoomControlDiv);
}

export function destroyPromise() {
  promise = null;
}


export function makeBoundsAroundCoordinate(center, radius) {
  const ne = window['google'].maps.geometry.spherical.computeOffset(center, radius, 45);
  const sw = window['google'].maps.geometry.spherical.computeOffset(center, radius, 225);
  return new window['google'].maps.LatLngBounds(sw, ne);
}
